import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { getAntivirusIndicator } from "components/helpers/antivirusStatus";
import Tooltip from "components/Tooltip";

export default function DocumentActionButton({
  onAction,
  isLoading,
  antivirusStatus,
  antivirusThreats,
  children,
  className,
  asLink,
}) {
  const { disabled, emoji, tooltip } = getAntivirusIndicator(
    antivirusStatus,
    antivirusThreats,
  );
  const isDisabled = isLoading || disabled;

  const button = (
    <button
      type="button"
      onClick={onAction}
      disabled={isDisabled}
      className={clsx(
        !asLink && "relative inline-block",
        disabled && "cursor-not-allowed",
        className,
      )}
    >
      <span className={clsx(isDisabled && "opacity-50")}>{children}</span>
      {emoji &&
        (asLink ? (
          <span className="ml-1 text-xs align-middle">{emoji}</span>
        ) : (
          <span className="absolute bottom-0 right-0 text-[8px] leading-none">
            {emoji}
          </span>
        ))}
    </button>
  );

  return tooltip ? <Tooltip content={tooltip}>{button}</Tooltip> : button;
}

DocumentActionButton.propTypes = {
  onAction: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  antivirusStatus: PropTypes.string,
  antivirusThreats: PropTypes.array,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  asLink: PropTypes.bool,
};
